<app-nav-header></app-nav-header>
<app-global-search></app-global-search>
  <router-outlet></router-outlet>
  <app-widget-rrss></app-widget-rrss>
<app-footer></app-footer>